export const getState = (state) => state.seatMap;
